/* Управління (/mgmt) і «Маркетинг: контент і збори» (/marketing/content), batch B16. Kept apart from uk.ts/en.ts to keep merges small. */
export const mgmtUk = {
  'nav.mgmt': 'Управління',
  'nav.content': 'Контент і збори',
  'perm.mgmt.read': 'Управління: наради, рішення, статистика лікарів (свої / лікарські)',
  'perm.mgmt.manage': 'Управління: протоколи нарад, рішення → задачі, уся статистика',
  'perm.content.contribute': 'Контент: теми статей, свої статті й рецензії, внески для бонусів',
  'process.area.marketing': 'Маркетинг',

  'mgmt.title': 'Управління',
  'mgmt.subtitle': 'Протоколи нарад, рішення з відповідальним і строком (у задачі одним кліком) і статистика лікарів за місяць. Час — київський.',
  'mgmt.tabMeetings': 'Наради',
  'mgmt.tabDecisions': 'Рішення',
  'mgmt.tabDoctors': 'Статистика лікарів',
  'mgmt.kind.planning': 'Планерка',
  'mgmt.kind.doctors': 'Лікарська нарада',
  'mgmt.kind.management': 'Нарада керівництва',
  'mgmt.status.planned': 'Запланована',
  'mgmt.status.held': 'Відбулася',
  'mgmt.status.cancelled': 'Скасована',
  'mgmt.branch.kharkiv': 'Харків',
  'mgmt.branch.kyiv': 'Київ',
  'mgmt.kindFilter': 'Тип наради',
  'mgmt.allKinds': 'Усі наради',
  'mgmt.searchMeetings': 'Питання, рішення, нотатки',
  'mgmt.newMeeting': 'Нова нарада',
  'mgmt.editMeeting': 'Редагувати нараду',
  'mgmt.meeting': 'Нарада',
  'mgmt.meetingHint': 'Питання порядку денного — по одному в рядок; рішення з відповідальним і строком додаються після збереження.',
  'mgmt.meetingSaved': 'Нараду збережено',
  'mgmt.noMeetings': 'Нарад ще немає',
  'mgmt.noMeetingsHint': 'Створіть нараду, впишіть питання — і фіксуйте рішення з відповідальним і строком. На наступній нараді відкриті рішення з’являться для перевірки.',
  'mgmt.noMeetingsReader': 'Тут з’являться лікарські наради і наради, де ви учасник або відповідальний за рішення.',
  'mgmt.col.date': 'Дата',
  'mgmt.col.meeting': 'Нарада',
  'mgmt.col.attendees': 'Учасники',
  'mgmt.col.decisions': 'Рішення',
  'mgmt.openOf': '{open} відкр. з {total}',
  'mgmt.noAttendees': 'учасників не вказано',
  'mgmt.followUp': 'Відкриті рішення з попередніх нарад',
  'mgmt.followUpHint': 'Пройдіться по списку: що виконано, що ні і чому. Відмітка «Перевірити» зберігає результат у протоколі цієї наради.',
  'mgmt.agenda': 'Порядок денний',
  'mgmt.noAgenda': 'Порядок денний порожній',
  'mgmt.noAgendaHint': 'Додайте питання в «Редагувати» або одразу зафіксуйте рішення.',
  'mgmt.addQuestion': 'Додати питання',
  'mgmt.question': 'Питання',
  'mgmt.noQuestion': 'Без питання',
  'mgmt.discussion': 'Суть обговорення (необов’язково)',
  'mgmt.decide': 'Рішення',
  'mgmt.addDecision': 'Додати рішення',
  'mgmt.editDecision': 'Редагувати рішення',
  'mgmt.decisionHint': 'Хто відповідальний і до коли. Задача з’явиться у відповідального в «Задачах» з нагадуванням про строк.',
  'mgmt.decisionText': 'Рішення',
  'mgmt.owner': 'Відповідальний',
  'mgmt.noOwner': 'Без відповідального',
  'mgmt.due': 'Строк',
  'mgmt.dueOn': 'до {date}',
  'mgmt.createTask': 'Створити задачу для відповідального',
  'mgmt.decisionSaved': 'Рішення збережено',
  'mgmt.decisionWithTask': 'Рішення збережено, задачу створено',
  'mgmt.otherDecisions': 'Інші рішення',
  'mgmt.task': 'Задача',
  'mgmt.makeTask': 'У задачу',
  'mgmt.taskCreated': 'Задачу створено',
  'mgmt.review': 'Перевірити',
  'mgmt.reviewTitle': 'Перевірка рішення',
  'mgmt.reviewStatus': 'Результат',
  'mgmt.reviewAs.open': 'Ще в роботі',
  'mgmt.reviewAs.done': 'Виконано',
  'mgmt.reviewAs.cancelled': 'Скасовано / неактуально',
  'mgmt.reviewNote': 'Що доповіли',
  'mgmt.reviewNoteHint': 'Для «Скасовано» причина обов’язкова.',
  'mgmt.reviewSaved': 'Результат збережено',
  'mgmt.lastReview': 'остання перевірка: {note}',
  'mgmt.decision.open': 'Відкриті',
  'mgmt.decision.done': 'Виконані',
  'mgmt.decision.cancelled': 'Скасовані',
  'mgmt.overdue': 'Прострочено',
  'mgmt.onlyMine': 'Лише мої',
  'mgmt.onlyOverdue': 'Лише прострочені',
  'mgmt.noDecisions': 'Рішень немає',
  'mgmt.noDecisionsHint': 'Рішення фіксуються в протоколі наради (вкладка «Наради»). Змініть фільтри, щоб побачити виконані.',
  'mgmt.kindLabel': 'Тип наради',
  'mgmt.heldAt': 'Дата і час',
  'mgmt.titleLabel': 'Назва',
  'mgmt.titleHint': 'Порожньо — «Планерка 15.06.2026».',
  'mgmt.branch': 'Філія',
  'mgmt.wholeClinic': 'Уся клініка',
  'mgmt.statusLabel': 'Статус',
  'mgmt.statusAuto': 'Автоматично за датою',
  'mgmt.attendees': 'Учасники',
  'mgmt.notes': 'Нотатки',
  'mgmt.needDate': 'Вкажіть дату і час наради.',
  'mgmt.needQuestion': 'Заповніть питання або видаліть порожній рядок.',
  'mgmt.needDecision': 'Напишіть рішення.',
  'mgmt.needReason': 'Напишіть причину.',
  'mgmt.prevMonth': 'Попередній місяць',
  'mgmt.nextMonth': 'Наступний місяць',
  'mgmt.statsNote': 'Дані Enote за місяць за київським часом. Повторні — пацієнти, які були в цього лікаря протягом попередніх 365 днів; аналізи вчасно — переглянуто за {hours} год.',
  'mgmt.statsNoMoney': 'Виручка і середній чек — лише для фінансової ролі.',
  'mgmt.notLinked': 'Ваш обліковий запис не пов’язаний з лікарем Enote',
  'mgmt.notLinkedHint': 'Попросіть адміністратора зіставити вас із працівником Enote — тоді тут з’явиться ваша статистика.',
  'mgmt.noStats': 'За цей місяць даних немає',
  'mgmt.noStatsHint': 'Статистика будується з візитів, синхронізованих з Enote. Оберіть інший місяць або перевірте синхронізацію.',
  'mgmt.col.doctor': 'Лікар',
  'mgmt.col.visits': 'Візити',
  'mgmt.col.patients': 'Пацієнти',
  'mgmt.col.repeat': 'Повторні',
  'mgmt.col.surgeries': 'Операції',
  'mgmt.col.inpatients': 'Стаціонар',
  'mgmt.col.recommendations': 'Рекомендації',
  'mgmt.col.rating': 'Оцінка',
  'mgmt.col.labOnTime': 'Аналізи вчасно',
  'mgmt.col.revenue': 'Виручка',
  'mgmt.col.avgCheck': 'Середній чек',
  'mgmt.repeatHint': '{n} пацієнтів уже були в цього лікаря',
  'mgmt.deaths': 'летальних: {n}',
  'mgmt.total': 'Разом',

  'content.title': 'Маркетинг: контент і збори',
  'content.subtitle': 'Трекер статей з рецензією лікаря, збори на лікування і бонуси персоналу за контент.',
  'content.tabArticles': 'Статті',
  'content.tabFundraising': 'Збори',
  'content.tabBonuses': 'Бонуси за контент',
  'content.searchArticles': 'Тема, автор, нотатки',
  'content.onlyMine': 'Мої (автор / рецензент)',
  'content.onlyOverdue': 'Прострочені',
  'content.proposeTopic': 'Запропонувати тему',
  'content.proposeHint': 'Тема потрапить у «Ідеї». Автор бере її в роботу — дедлайн 14 днів, рецензія лікаря, публікація.',
  'content.proposed': 'Тему додано в ідеї',
  'content.editArticle': 'Редагувати статтю',
  'content.saved': 'Збережено',
  'content.moved': 'Статус змінено',
  'content.noArticles': 'Контент-план порожній',
  'content.noArticlesHint': 'Запропонуйте тему — автор бере її в роботу з дедлайном {days} днів, лікар рецензує, маркетолог публікує.',
  'content.status.idea': 'Ідеї',
  'content.status.draft': 'В роботі',
  'content.status.medical_review': 'Рецензія лікаря',
  'content.status.approved': 'Прийнято',
  'content.status.published': 'Опубліковано',
  'content.status.cancelled': 'Скасовано',
  'content.columnEmpty.idea': 'Вільних тем немає',
  'content.columnEmpty.draft': 'Ніхто не пише',
  'content.columnEmpty.medical_review': 'Рецензій не чекає',
  'content.columnEmpty.approved': 'Усе прийняте опубліковано',
  'content.columnEmpty.published': 'Ще нічого не опубліковано',
  'content.kind.article': 'Стаття',
  'content.kind.news': 'Новина',
  'content.kind.seo_page': 'SEO-сторінка',
  'content.kind.post': 'Пост',
  'content.kind.video': 'Відео',
  'content.daysLeft': '{n} дн',
  'content.dueToday': 'сьогодні',
  'content.overdueDays': 'прострочено {n} дн',
  'content.article': 'Стаття',
  'content.author': 'Автор',
  'content.freeTopic': 'вільна тема',
  'content.reviewer': 'Лікар-рецензент',
  'content.chooseReviewer': 'Оберіть лікаря',
  'content.takenOn': 'Взято',
  'content.deadline': 'Дедлайн',
  'content.cityLang': 'Місто / мова',
  'content.clinicalPosition': 'Клінічна позиція',
  'content.positionHint': 'Офіційна позиція клініки, якої має дотримуватися текст (вік стерилізації, голодування перед наркозом тощо).',
  'content.positionUrl': 'Посилання на позицію',
  'content.noPosition': 'не вказано — узгодьте з лікарем-рецензентом',
  'content.links': 'Посилання',
  'content.briefUrl': 'ТЗ',
  'content.draftUrl': 'Текст',
  'content.draftUrlHint': 'Документ з текстом (Google Docs), назва «Прізвище — Назва».',
  'content.publishUrl': 'Опубліковано',
  'content.open': 'відкрити',
  'content.reviewNote': 'Рецензія',
  'content.history': 'Історія',
  'content.paid': 'Оплачено',
  'content.unpaid': 'Не оплачено',
  'content.markPaid': 'Гонорар оплачено',
  'content.fee': 'Гонорар',
  'content.feeHint': 'Видно лише фінансовій ролі. Оплата — після «Прийнято».',
  'content.topic': 'Тема',
  'content.kindLabel': 'Формат',
  'content.city': 'Місто',
  'content.language': 'Мова',
  'content.authorName': 'Зовнішній автор',
  'content.authorNameHint': 'Копірайтер без облікового запису.',
  'content.externalOrFree': 'Зовнішній автор / вільна тема',
  'content.notes': 'Нотатки',
  'content.remarks': 'Що доопрацювати',
  'content.cancelReason': 'Причина',
  'content.needTopic': 'Напишіть тему.',
  'content.needDraft': 'Додайте посилання на текст.',
  'content.needReviewer': 'Оберіть лікаря-рецензента.',
  'content.needPublishUrl': 'Додайте посилання на опубліковану статтю.',
  'content.needNote': 'Напишіть коментар.',
  'content.badAmount': 'Сума — число, наприклад 1250,50',
  'content.step.idea.draft': 'Взяти в роботу',
  'content.step.draft.medical_review': 'Надіслати на рецензію',
  'content.step.draft.idea': 'Звільнити тему',
  'content.step.medical_review.approved': 'Прийнято',
  'content.step.medical_review.draft': 'На доопрацювання',
  'content.step.medical_review.published': 'Опублікувати',
  'content.step.approved.published': 'Опублікувати',
  'content.step.cancelled.idea': 'Повернути в ідеї',
  'content.step.cancel': 'Скасувати',
  'content.event.created': 'створено',
  'content.event.updated': 'змінено',
  'content.event.taken': 'взято в роботу',
  'content.event.released': 'тему звільнено',
  'content.event.submitted': 'надіслано на рецензію',
  'content.event.returned': 'на доопрацювання',
  'content.event.approved': 'прийнято',
  'content.event.published': 'опубліковано',
  'content.event.cancelled': 'скасовано',
  'content.event.reopened': 'повернуто в ідеї',
  'content.event.paid': 'гонорар оплачено',
  'content.event.unpaid': 'оплату скасовано',

  'content.fr.title': 'Збір',
  'content.fr.new': 'Новий збір',
  'content.fr.edit': 'Редагувати збір',
  'content.fr.hint': 'Програма підтримки: клієнт не може оплатити лікування — банка, пост, звіт донорам. Надходження вносяться вручну.',
  'content.fr.saved': 'Збір збережено',
  'content.fr.empty': 'Зборів ще немає',
  'content.fr.emptyHint': 'Створіть збір: пацієнт, сума-ціль, посилання на банку і строк. Вносьте надходження — прогрес і звіт донорам рахуються тут.',
  'content.fr.emptyReader': 'Тут з’являться збори на лікування пацієнтів, які веде маркетолог.',
  'content.fr.statusFilter': 'Статус',
  'content.fr.status.active': 'Триває',
  'content.fr.status.closed': 'Закрито',
  'content.fr.status.reported': 'Звіт надіслано',
  'content.fr.status.cancelled': 'Скасовано',
  'content.fr.ended': 'Строк минув',
  'content.fr.until': 'до {date}',
  'content.fr.name': 'Назва збору',
  'content.fr.patient': 'Пацієнт',
  'content.fr.goal': 'Ціль, грн',
  'content.fr.collected': 'Зібрано',
  'content.fr.spent': 'Витрачено на лікування',
  'content.fr.charity': 'Благодійна організація',
  'content.fr.contract': 'Договір з клієнтом',
  'content.fr.page': 'Банка / пост',
  'content.fr.starts': 'Початок',
  'content.fr.deadline': 'Строк',
  'content.fr.owner': 'Відповідальний',
  'content.fr.me': 'Я',
  'content.fr.description': 'Опис',
  'content.fr.entries': 'Надходження і витрати',
  'content.fr.noEntries': 'Записів ще немає. Вносьте суми з банки після кожного звіту банку.',
  'content.fr.kind': 'Тип',
  'content.fr.donation': 'Надходження',
  'content.fr.spentEntry': 'Витрата',
  'content.fr.amount': 'Сума',
  'content.fr.source': 'Джерело',
  'content.fr.date': 'Дата',
  'content.fr.note': 'Примітка',
  'content.fr.entryAdded': 'Запис додано',
  'content.fr.report': 'Звіт донорам',
  'content.fr.reportHint': 'Скільки зібрано, на що витрачено, як почувається пацієнт.',
  'content.fr.useDraft': 'Підставити чернетку',
  'content.fr.saveReport': 'Зберегти звіт і закрити збір',
  'content.fr.updateReport': 'Оновити звіт',
  'content.fr.reported': 'Звіт збережено',
  'content.fr.needTitle': 'Напишіть назву збору.',
  'content.fr.needGoal': 'Вкажіть суму-ціль.',
  'content.source.jar': 'Банка',
  'content.source.card': 'Картка',
  'content.source.cash': 'Готівка',
  'content.source.transfer': 'Переказ',
  'content.source.treatment': 'Лікування',
  'content.source.other': 'Інше',

  'content.b.add': 'Додати мій контент',
  'content.b.addHint': 'Пост, сторіс, відео чи стаття з відміткою клініки. Маркетолог перевірить і нарахує бали за місяць.',
  'content.b.note': 'Бали нараховуються після перевірки маркетологом; зведення за місяць іде у зарплатну відомість. Суми бонусів бачить лише фінансова роль.',
  'content.b.empty': 'За цей місяць внесків немає',
  'content.b.emptyHint': 'Натисніть «Додати мій контент» і вставте посилання на публікацію з відміткою клініки.',
  'content.b.kind': 'Вид',
  'content.b.url': 'Посилання на публікацію',
  'content.b.title': 'Опис (необов’язково)',
  'content.b.published': 'Опубліковано',
  'content.b.monthHint': 'Зараховується в місяць публікації.',
  'content.b.status': 'Статус',
  'content.b.pointsN': '{n} б.',
  'content.b.approve': 'Зарахувати',
  'content.b.approved': 'Зараховано',
  'content.b.reject': 'Відхилити',
  'content.b.saved': 'Внесок додано — чекає перевірки',
  'content.b.needKind': 'Оберіть вид.',
  'content.b.needDate': 'Вкажіть дату публікації.',
  'content.b.summary': 'Зведення за місяць для відомості',
  'content.b.summaryEmpty': 'Зарахованих внесків за місяць немає.',
  'content.b.items': 'Зараховано',
  'content.b.rates': 'Види контенту і бали',
  'content.b.amountPerItem': 'Бонус за одиницю',
  'content.b.toConfirm': 'уточнити',
  'content.b.inactive': 'вимкнено',
  'content.b.editRate': 'Вид контенту',
  'content.b.confirmed': 'Погоджено власником',
  'content.b.active': 'Активний',
  'content.b.badPoints': 'Бали — ціле число від 0.',
  'content.contrib.submitted': 'На перевірці',
  'content.contrib.approved': 'Зараховано',
  'content.contrib.rejected': 'Відхилено',
  'content.col.staff': 'Працівник',
  'content.col.points': 'Бали',
  'content.col.pending': 'На перевірці',
  'content.col.bonus': 'Бонус',
  'content.col.articleFees': 'Гонорари за статті',
}

export const mgmtEn: { [K in keyof typeof mgmtUk]?: string } = {
  'nav.mgmt': 'Management',
  'nav.content': 'Content & fundraising',
  'perm.mgmt.read': 'Management: meetings, decisions, doctor statistics (own / doctors’)',
  'perm.mgmt.manage': 'Management: meeting minutes, decisions → tasks, all statistics',
  'perm.content.contribute': 'Content: article topics, own articles and reviews, bonus contributions',
  'process.area.marketing': 'Marketing',
  'mgmt.title': 'Management',
  'mgmt.subtitle': 'Meeting minutes, decisions with an owner and a due date (a task in one click) and monthly doctor statistics. Kyiv time.',
  'mgmt.tabMeetings': 'Meetings',
  'mgmt.tabDecisions': 'Decisions',
  'mgmt.tabDoctors': 'Doctor statistics',
  'mgmt.kind.planning': 'Planning meeting',
  'mgmt.kind.doctors': 'Doctors’ meeting',
  'mgmt.kind.management': 'Management meeting',
  'mgmt.status.planned': 'Planned',
  'mgmt.status.held': 'Held',
  'mgmt.status.cancelled': 'Cancelled',
  'mgmt.branch.kharkiv': 'Kharkiv',
  'mgmt.branch.kyiv': 'Kyiv',
  'mgmt.kindFilter': 'Meeting type',
  'mgmt.allKinds': 'All meetings',
  'mgmt.searchMeetings': 'Questions, decisions, notes',
  'mgmt.newMeeting': 'New meeting',
  'mgmt.editMeeting': 'Edit meeting',
  'mgmt.meeting': 'Meeting',
  'mgmt.meetingHint': 'One agenda question per line; decisions with an owner and a due date are added after saving.',
  'mgmt.meetingSaved': 'Meeting saved',
  'mgmt.noMeetings': 'No meetings yet',
  'mgmt.noMeetingsHint': 'Create a meeting, add the questions and record decisions with an owner and a due date. Open decisions come back for review at the next meeting.',
  'mgmt.noMeetingsReader': 'Doctors’ meetings and meetings you attend or own a decision of will appear here.',
  'mgmt.col.date': 'Date',
  'mgmt.col.meeting': 'Meeting',
  'mgmt.col.attendees': 'Attendees',
  'mgmt.col.decisions': 'Decisions',
  'mgmt.openOf': '{open} open of {total}',
  'mgmt.noAttendees': 'no attendees',
  'mgmt.followUp': 'Open decisions of earlier meetings',
  'mgmt.followUpHint': 'Go through the list: what is done, what is not and why. «Review» stores the result in this meeting’s minutes.',
  'mgmt.agenda': 'Agenda',
  'mgmt.noAgenda': 'The agenda is empty',
  'mgmt.noAgendaHint': 'Add questions with «Edit» or record a decision right away.',
  'mgmt.addQuestion': 'Add question',
  'mgmt.question': 'Question',
  'mgmt.noQuestion': 'No question',
  'mgmt.discussion': 'Discussion (optional)',
  'mgmt.decide': 'Decision',
  'mgmt.addDecision': 'Add decision',
  'mgmt.editDecision': 'Edit decision',
  'mgmt.decisionHint': 'Who owns it and by when. The owner gets a task with a due-date reminder.',
  'mgmt.decisionText': 'Decision',
  'mgmt.owner': 'Owner',
  'mgmt.noOwner': 'No owner',
  'mgmt.due': 'Due',
  'mgmt.dueOn': 'by {date}',
  'mgmt.createTask': 'Create a task for the owner',
  'mgmt.decisionSaved': 'Decision saved',
  'mgmt.decisionWithTask': 'Decision saved, task created',
  'mgmt.otherDecisions': 'Other decisions',
  'mgmt.task': 'Task',
  'mgmt.makeTask': 'To task',
  'mgmt.taskCreated': 'Task created',
  'mgmt.review': 'Review',
  'mgmt.reviewTitle': 'Decision follow-up',
  'mgmt.reviewStatus': 'Result',
  'mgmt.reviewAs.open': 'Still in progress',
  'mgmt.reviewAs.done': 'Done',
  'mgmt.reviewAs.cancelled': 'Cancelled / no longer relevant',
  'mgmt.reviewNote': 'What was reported',
  'mgmt.reviewNoteHint': 'A reason is required for «Cancelled».',
  'mgmt.reviewSaved': 'Result saved',
  'mgmt.lastReview': 'last review: {note}',
  'mgmt.decision.open': 'Open',
  'mgmt.decision.done': 'Done',
  'mgmt.decision.cancelled': 'Cancelled',
  'mgmt.overdue': 'Overdue',
  'mgmt.onlyMine': 'Mine only',
  'mgmt.onlyOverdue': 'Overdue only',
  'mgmt.noDecisions': 'No decisions',
  'mgmt.noDecisionsHint': 'Decisions are recorded in meeting minutes («Meetings» tab). Change the filters to see completed ones.',
  'mgmt.kindLabel': 'Meeting type',
  'mgmt.heldAt': 'Date and time',
  'mgmt.titleLabel': 'Title',
  'mgmt.titleHint': 'Empty — «Planning meeting 15.06.2026».',
  'mgmt.branch': 'Branch',
  'mgmt.wholeClinic': 'Whole clinic',
  'mgmt.statusLabel': 'Status',
  'mgmt.statusAuto': 'Automatic by date',
  'mgmt.attendees': 'Attendees',
  'mgmt.notes': 'Notes',
  'mgmt.needDate': 'Enter the meeting date and time.',
  'mgmt.needQuestion': 'Fill in the question or remove the empty line.',
  'mgmt.needDecision': 'Write the decision.',
  'mgmt.needReason': 'Write the reason.',
  'mgmt.prevMonth': 'Previous month',
  'mgmt.nextMonth': 'Next month',
  'mgmt.statsNote': 'Enote data for the Kyiv month. Repeat — patients seen by this doctor in the previous 365 days; labs on time — reviewed within {hours} h.',
  'mgmt.statsNoMoney': 'Revenue and average check are for the finance role only.',
  'mgmt.notLinked': 'Your account is not linked to an Enote doctor',
  'mgmt.notLinkedHint': 'Ask an administrator to map you to your Enote employee — your statistics will appear here.',
  'mgmt.noStats': 'No data for this month',
  'mgmt.noStatsHint': 'Statistics are built from visits synced from Enote. Pick another month or check the sync.',
  'mgmt.col.doctor': 'Doctor',
  'mgmt.col.visits': 'Visits',
  'mgmt.col.patients': 'Patients',
  'mgmt.col.repeat': 'Repeat',
  'mgmt.col.surgeries': 'Surgeries',
  'mgmt.col.inpatients': 'Inpatients',
  'mgmt.col.recommendations': 'Recommendations',
  'mgmt.col.rating': 'Rating',
  'mgmt.col.labOnTime': 'Labs on time',
  'mgmt.col.revenue': 'Revenue',
  'mgmt.col.avgCheck': 'Average check',
  'mgmt.repeatHint': '{n} patients had seen this doctor before',
  'mgmt.deaths': 'deaths: {n}',
  'mgmt.total': 'Total',
  'content.title': 'Marketing: content & fundraising',
  'content.subtitle': 'Article tracker with doctor review, fundraising for treatment and staff content bonuses.',
  'content.tabArticles': 'Articles',
  'content.tabFundraising': 'Fundraising',
  'content.tabBonuses': 'Content bonuses',
  'content.searchArticles': 'Topic, author, notes',
  'content.onlyMine': 'Mine (author / reviewer)',
  'content.onlyOverdue': 'Overdue',
  'content.proposeTopic': 'Propose a topic',
  'content.proposeHint': 'The topic goes to «Ideas». An author takes it — 14-day deadline, doctor review, publication.',
  'content.proposed': 'Topic added to ideas',
  'content.editArticle': 'Edit article',
  'content.saved': 'Saved',
  'content.moved': 'Status changed',
  'content.noArticles': 'The content plan is empty',
  'content.noArticlesHint': 'Propose a topic — an author takes it with a {days}-day deadline, a doctor reviews, marketing publishes.',
  'content.status.idea': 'Ideas',
  'content.status.draft': 'In progress',
  'content.status.medical_review': 'Doctor review',
  'content.status.approved': 'Accepted',
  'content.status.published': 'Published',
  'content.status.cancelled': 'Cancelled',
  'content.columnEmpty.idea': 'No free topics',
  'content.columnEmpty.draft': 'Nobody is writing',
  'content.columnEmpty.medical_review': 'No reviews waiting',
  'content.columnEmpty.approved': 'Everything accepted is published',
  'content.columnEmpty.published': 'Nothing published yet',
  'content.kind.article': 'Article',
  'content.kind.news': 'News',
  'content.kind.seo_page': 'SEO page',
  'content.kind.post': 'Post',
  'content.kind.video': 'Video',
  'content.daysLeft': '{n} d',
  'content.dueToday': 'today',
  'content.overdueDays': '{n} d overdue',
  'content.article': 'Article',
  'content.author': 'Author',
  'content.freeTopic': 'free topic',
  'content.reviewer': 'Doctor reviewer',
  'content.chooseReviewer': 'Choose a doctor',
  'content.takenOn': 'Taken',
  'content.deadline': 'Deadline',
  'content.cityLang': 'City / language',
  'content.clinicalPosition': 'Clinical position',
  'content.positionHint': 'The clinic’s official position the text must follow (spay age, fasting before anaesthesia, …).',
  'content.positionUrl': 'Position link',
  'content.noPosition': 'not set — agree with the doctor reviewer',
  'content.links': 'Links',
  'content.briefUrl': 'Brief',
  'content.draftUrl': 'Text',
  'content.draftUrlHint': 'Document with the text (Google Docs), named «Surname — Title».',
  'content.publishUrl': 'Published',
  'content.open': 'open',
  'content.reviewNote': 'Review',
  'content.history': 'History',
  'content.paid': 'Paid',
  'content.unpaid': 'Unpaid',
  'content.markPaid': 'Fee paid',
  'content.fee': 'Fee',
  'content.feeHint': 'Visible to the finance role only. Paid after «Accepted».',
  'content.topic': 'Topic',
  'content.kindLabel': 'Format',
  'content.city': 'City',
  'content.language': 'Language',
  'content.authorName': 'External author',
  'content.authorNameHint': 'Copywriter without an account.',
  'content.externalOrFree': 'External author / free topic',
  'content.notes': 'Notes',
  'content.remarks': 'What to fix',
  'content.cancelReason': 'Reason',
  'content.needTopic': 'Write the topic.',
  'content.needDraft': 'Add the link to the text.',
  'content.needReviewer': 'Choose a doctor reviewer.',
  'content.needPublishUrl': 'Add the link to the published article.',
  'content.needNote': 'Write a comment.',
  'content.badAmount': 'Amount is a number, e.g. 1250.50',
  'content.step.idea.draft': 'Take the topic',
  'content.step.draft.medical_review': 'Send for review',
  'content.step.draft.idea': 'Release the topic',
  'content.step.medical_review.approved': 'Accept',
  'content.step.medical_review.draft': 'Return for rework',
  'content.step.medical_review.published': 'Publish',
  'content.step.approved.published': 'Publish',
  'content.step.cancelled.idea': 'Back to ideas',
  'content.step.cancel': 'Cancel',
  'content.event.created': 'created',
  'content.event.updated': 'edited',
  'content.event.taken': 'taken',
  'content.event.released': 'topic released',
  'content.event.submitted': 'sent for review',
  'content.event.returned': 'returned for rework',
  'content.event.approved': 'accepted',
  'content.event.published': 'published',
  'content.event.cancelled': 'cancelled',
  'content.event.reopened': 'back to ideas',
  'content.event.paid': 'fee paid',
  'content.event.unpaid': 'payment undone',
  'content.fr.title': 'Campaign',
  'content.fr.new': 'New campaign',
  'content.fr.edit': 'Edit campaign',
  'content.fr.hint': 'Support programme: the client cannot pay for treatment — bank jar, post, report to donors. Entries are added by hand.',
  'content.fr.saved': 'Campaign saved',
  'content.fr.empty': 'No campaigns yet',
  'content.fr.emptyHint': 'Create a campaign: patient, goal, jar link and deadline. Add entries — progress and the donors’ report are computed here.',
  'content.fr.emptyReader': 'Fundraising campaigns for patients run by marketing will appear here.',
  'content.fr.statusFilter': 'Status',
  'content.fr.status.active': 'Active',
  'content.fr.status.closed': 'Closed',
  'content.fr.status.reported': 'Reported',
  'content.fr.status.cancelled': 'Cancelled',
  'content.fr.ended': 'Deadline passed',
  'content.fr.until': 'until {date}',
  'content.fr.name': 'Campaign title',
  'content.fr.patient': 'Patient',
  'content.fr.goal': 'Goal, UAH',
  'content.fr.collected': 'Collected',
  'content.fr.spent': 'Spent on treatment',
  'content.fr.charity': 'Charity organisation',
  'content.fr.contract': 'Contract with the client',
  'content.fr.page': 'Jar / post',
  'content.fr.starts': 'Start',
  'content.fr.deadline': 'Deadline',
  'content.fr.owner': 'Owner',
  'content.fr.me': 'Me',
  'content.fr.description': 'Description',
  'content.fr.entries': 'Donations and spending',
  'content.fr.noEntries': 'No entries yet. Add the jar amounts after each bank statement.',
  'content.fr.kind': 'Type',
  'content.fr.donation': 'Donation',
  'content.fr.spentEntry': 'Spending',
  'content.fr.amount': 'Amount',
  'content.fr.source': 'Source',
  'content.fr.date': 'Date',
  'content.fr.note': 'Note',
  'content.fr.entryAdded': 'Entry added',
  'content.fr.report': 'Report to donors',
  'content.fr.reportHint': 'How much was collected, what it paid for, how the patient is.',
  'content.fr.useDraft': 'Use the draft',
  'content.fr.saveReport': 'Save the report and close',
  'content.fr.updateReport': 'Update the report',
  'content.fr.reported': 'Report saved',
  'content.fr.needTitle': 'Write the campaign title.',
  'content.fr.needGoal': 'Enter the goal amount.',
  'content.source.jar': 'Jar',
  'content.source.card': 'Card',
  'content.source.cash': 'Cash',
  'content.source.transfer': 'Transfer',
  'content.source.treatment': 'Treatment',
  'content.source.other': 'Other',
  'content.b.add': 'Add my content',
  'content.b.addHint': 'A post, story, video or article with the clinic mark. Marketing reviews it and adds the points to the month.',
  'content.b.note': 'Points count after marketing review; the monthly summary goes to the payroll. Bonus amounts are visible to the finance role only.',
  'content.b.empty': 'No contributions this month',
  'content.b.emptyHint': 'Click «Add my content» and paste the link to a publication with the clinic mark.',
  'content.b.kind': 'Kind',
  'content.b.url': 'Publication link',
  'content.b.title': 'Description (optional)',
  'content.b.published': 'Published',
  'content.b.monthHint': 'Counted in the month of publication.',
  'content.b.status': 'Status',
  'content.b.pointsN': '{n} pts',
  'content.b.approve': 'Approve',
  'content.b.approved': 'Approved',
  'content.b.reject': 'Reject',
  'content.b.saved': 'Contribution added — waiting for review',
  'content.b.needKind': 'Choose the kind.',
  'content.b.needDate': 'Enter the publication date.',
  'content.b.summary': 'Monthly summary for the payroll',
  'content.b.summaryEmpty': 'No approved contributions this month.',
  'content.b.items': 'Approved',
  'content.b.rates': 'Content kinds and points',
  'content.b.amountPerItem': 'Bonus per item',
  'content.b.toConfirm': 'to confirm',
  'content.b.inactive': 'off',
  'content.b.editRate': 'Content kind',
  'content.b.confirmed': 'Confirmed by the owner',
  'content.b.active': 'Active',
  'content.b.badPoints': 'Points are a whole number from 0.',
  'content.contrib.submitted': 'In review',
  'content.contrib.approved': 'Approved',
  'content.contrib.rejected': 'Rejected',
  'content.col.staff': 'Staff member',
  'content.col.points': 'Points',
  'content.col.pending': 'In review',
  'content.col.bonus': 'Bonus',
  'content.col.articleFees': 'Article fees',
}
